import ArrowIcon from './arrow.svg';
import ArticlesIcon from './articles.svg';
import AudioIcon from './audio.svg';
import AvatarIcon from './avatar.svg';
import BanIcon from './ban.svg';
import BookIcon from './book.svg';
import BookShadowIcon from './book-shadow.svg';
import CalendarIcon from './calendar.svg';
import CheckIcon from './check.svg';
import CheckMarkIcon from './check-mark.svg';
import ChevronUpIcon from './chevron-up.svg';
import CloseIcon from './close.svg';
import CompanyIcon from './company.svg';
import CopyIcon from './copy.svg';
import DeleteIcon from './delete.svg';
import DotsVerticalIcon from './dots-vertical.svg';
import DragHandleIcon from './drag-handle.svg';
import EditIcon from './edit.svg';
import ErrorIcon from './error.svg';
import HamburgerIcon from './hamburger.svg';
import InfoIcon from './info.svg';
import LibrarianIcon from './librarian.svg';
import LibraryIcon from './library.svg';
import LinkIcon from './link.svg';
import LockIcon from './lock.svg';
import LogoIcon from './logo.svg';
import PanelIcon from './panel.svg';
import PlusIcon from './plus.svg';
import SearchIcon from './search.svg';
import SettingsIcon from './settings.svg';
import ShareIcon from './share.svg';
import SparkleIcon from './sparkle.svg';
import StarIcon from './star.svg';
import TagIcon from './tag.svg';
import ToolsIcon from './tools.svg';
import UxcoreIcon from './uxcore.svg';
import VideoIcon from './video.svg';
import VideoShadowIcon from './video-shadow.svg';

export {
  ArrowIcon,
  ArticlesIcon,
  AudioIcon,
  AvatarIcon,
  BanIcon,
  BookIcon,
  BookShadowIcon,
  CalendarIcon,
  CheckIcon,
  CheckMarkIcon,
  ChevronUpIcon,
  CloseIcon,
  CompanyIcon,
  CopyIcon,
  DeleteIcon,
  DotsVerticalIcon,
  DragHandleIcon,
  EditIcon,
  ErrorIcon,
  HamburgerIcon,
  InfoIcon,
  LibrarianIcon,
  LibraryIcon,
  LinkIcon,
  LockIcon,
  LogoIcon,
  PanelIcon,
  PlusIcon,
  SearchIcon,
  SettingsIcon,
  ShareIcon,
  SparkleIcon,
  StarIcon,
  TagIcon,
  ToolsIcon,
  UxcoreIcon,
  VideoIcon,
  VideoShadowIcon,
};
